<template>
  <v-app id="app">
    <NavigationDrawer />
    <v-main id="main-content">
      <!-- <v-btn
        class="ml-4 my-4"
        @click="changeLocale()">
        Language : {{ $i18n.locale }}
      </v-btn> -->
      <v-fade-transition mode="out-in">
        <router-view class="content" />
      </v-fade-transition>
      <Loading />
    </v-main>
  </v-app>
</template>

<script>
import NavigationDrawer from '@/components/NavigationDrawer.vue'
import Loading from '@/components/Loading.vue'

export default {
  name: 'DefaultLayout',
  components: {
    NavigationDrawer,
    Loading
  },
  data () {
    return {
    }
  },
  methods: {
    changeLocale () {
      if (this.$i18n.locale === 'en') {
        this.$i18n.locale = 'th'
      } else {
        this.$i18n.locale = 'en'
      }
    }
  }
}
</script>

<style lang="scss">
.v-dialog{
overflow-y: unset !important;
}
.btnlinear{
  background: linear-gradient(135deg, #0E153A 0%, #219DAB 100%);
}

#main-content{
  :deep(.v-input__slot){
  background: #FFFFFF;
}
}

.content {
  padding: 15px;
}

// #app{
//   font-family: 'Prompt';
//   font-style: normal;
//   font-size: 14px;
// }
// <------ css v-tab ------>
.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th{
  color: #FFFFFF;
}
.v-tab--active{
background: #195c76;
}
.v-tabs-slider-wrapper{
z-index: 0 !important;
}
.v-slide-group__content.v-tabs-bar__content{
background: #EEFAFC;
}
// <------ css data-table ------>

// .v-data-table__wrapper{
//   border-radius: 10px;
// }
</style>
